import './clients/datadog';
import './utils';

import { QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import React, { Suspense } from 'react';
import { BrowserRouter as Router } from 'react-router-dom';

import { queryClient } from './clients';
import { AppLoader } from './components/atoms';
import { ErrorBoundary, ScrollToTop } from './components/molecules';
import {
  NotificationProvider,
  AuthProvider,
  BootstrapProvider,
  ToastProvider,
  UnderMaintenance,
  NetworkCheckerProvider
} from './components/providers';
import { PageViewEventProvider } from './components/providers/PageViewEventProvider';
import ValidationErrorsProvider from './components/providers/ValidationErrorsProvider';
import { configs } from './configs';
import { RenderRoutes } from './routes';
import { GlobalStyle } from './styles';
import { bootstrap } from './utils/general';

bootstrap();

export function App() {
  return (
    <Suspense fallback={<AppLoader hasLogos={false} />}>
      <QueryClientProvider client={queryClient}>
        <Router basename={configs.appBaseUrl}>
          <ErrorBoundary>
            <BootstrapProvider>
              <GlobalStyle />
              <AuthProvider>
                <ScrollToTop>
                  <UnderMaintenance>
                    <ValidationErrorsProvider>
                      <RenderRoutes />
                      <NotificationProvider />
                      <NetworkCheckerProvider />
                    </ValidationErrorsProvider>
                  </UnderMaintenance>
                </ScrollToTop>
                <ToastProvider />
              </AuthProvider>
            </BootstrapProvider>
          </ErrorBoundary>
          <PageViewEventProvider />
        </Router>
        <ReactQueryDevtools initialIsOpen={false} position="bottom-right" />
      </QueryClientProvider>
    </Suspense>
  );
}
